import { contextIdConfig } from '../config';
import { useAuthMutation } from '../../common/apiUtils/queryHelper';
import { TCreateSearchResourcePayload } from '../types/types';
import { useQueryClient } from 'react-query';

const { create_context_resource, get_contextid, get_context_resources } =
  contextIdConfig;

export const useCreateContextIdResource = ({
  sitecoreContextId,
}: {
  sitecoreContextId: string;
}) => {
  const queryClient = useQueryClient();

  return useAuthMutation(
    (axiosInstance) => (payload: TCreateSearchResourcePayload) =>
      axiosInstance?.post(
        create_context_resource.url(sitecoreContextId),
        payload,
      ),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(
          get_contextid.queryKey(sitecoreContextId),
        );
        queryClient.invalidateQueries(
          get_context_resources.queryKey(sitecoreContextId),
        );
      },
    },
    create_context_resource.scope,
  );
};
